export const RTL_MODE = document.body.classList.contains("ar");
